import { useTranslate } from '@tolgee/react';
import { useIsSbsMode } from '../useIsSbs';
import { QIFeature } from 'utils/featureFlag';
import { useCallback, useMemo } from 'react';
import { useConversationReadonlyValue } from '../conversation';
import useIM from '../im/useIM';
import { message } from 'antd';
import { toUpperCase } from 'utils/toLowerCase';
import { getOrderStatusLabel } from 'services/i18n/enum/order';

export const useOrderStatusLabel = (tradeStatus: Conversation.Trade.Status) => {
  const { t } = useTranslate();

  return getOrderStatusLabel(t, tradeStatus);
};

/**
 * 获取订单发送按钮信息
 */
const NOT_SUPPORT_SEND_CHANNEL: Conversation.Conversation['channel'][] = ['MERCADO', 'TOKOPEDIA'];
export const useOrderSendButtonInfo = (
  order: Conversation.Trade.Vo,
  conversation: Conversation.Conversation,
  sendable: boolean,
) => {
  const isSbsMode = useIsSbsMode();
  const readonly = useConversationReadonlyValue();
  const { sendOrder } = useIM();
  const { t } = useTranslate();

  const { conversationId, controlStatus, isAffiliateSip } = conversation;
  const { platform, externalShopId, externalTradeId } = order;

  const sendEnabled = useMemo(() => {
    return !isSbsMode && !QIFeature && !NOT_SUPPORT_SEND_CHANNEL.includes(toUpperCase(platform));
  }, [isSbsMode, platform]);

  const sendDisabled = useMemo(() => {
    return readonly || controlStatus === false || !sendable || isAffiliateSip;
  }, [readonly, controlStatus, sendable, isAffiliateSip]);

  const sendHandler = useCallback(async () => {
    try {
      await sendOrder(conversationId, {
        externalStoreId: externalShopId,
        orderSn: externalTradeId,
      });
    } catch (error) {
      message.error(t('trade.sendFailed'));
    }
  }, [conversationId, externalShopId, externalTradeId, sendOrder, t]);

  return {
    sendEnabled,
    sendDisabled,
    sendHandler,
  };
};
